import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { Form, Button, TextArea } from 'formik-semantic-ui';
import { TranslationComponent } from '../TranslationComponent';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';

export interface PtwWorkCompletionModalValues {
  extraWork: boolean;
  extraWorkNotes: string;
}

interface PtwWorkCompletionModalProps {
  i18n: typeof i18n;
  t: typeof i18n.t;
  onSubmit: (values: PtwWorkCompletionModalValues) => void;
}

class PPtwWorkCompletionModal extends Component<PtwWorkCompletionModalProps> {
  state: { open: boolean } = {
    open: false,
  };

  toggleOpen = (open: boolean) => {
    this.setState({ open });
  };

  render() {
    const { t } = this.props;

    return (
      <Modal
        open={this.state.open}
        onClose={() => this.toggleOpen(false)}
        trigger={
          <Button primary onClick={() => this.toggleOpen(true)}>
            <TranslationComponent stringKey={'Close'} />
          </Button>
        }
      >
        <Modal.Header>
          <TranslationComponent stringKey={'Close'} />
        </Modal.Header>
        <Modal.Content>
          <Form
            initialValues={{ extraWork: false, extraWorkNotes: '' }}
            onSubmit={(values: PtwWorkCompletionModalValues) => {
              this.toggleOpen(false);
              this.props.onSubmit(values);
            }}
            render={({ setFieldValue, submitForm, values }) => (
              <Form.Children>
                <TextArea label={t('Extra work')} name="extraWorkNotes" />
                <Button
                  primary
                  disabled={values.extraWorkNotes === ''}
                  onClick={() => {
                    setFieldValue('extraWork', true);
                    submitForm();
                  }}
                >
                  <TranslationComponent stringKey={'YES'} />
                </Button>

                <Button primary onClick={submitForm}>
                  <TranslationComponent stringKey={'NO'} />
                </Button>

                <Button basic onClick={() => this.toggleOpen(false)}>
                  <TranslationComponent stringKey={'Cancel'} />
                </Button>
              </Form.Children>
            )}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

export const PtwWorkCompletionModal = withTranslation()(PPtwWorkCompletionModal);
